export default {
  title: "Colaboradores",
  description: "Invita personas para ayudarte con la planificación de tu boda",
  count: "{{count}} colaboradores",
  invite: "Invitar colaborador",
  rolesTitle: "Roles disponibles",
  roles: {
    admin: "Administrador",
    editor: "Editor",
    viewer: "Observador"
  },
  roleDescriptions: {
    admin: "Puede modificar todo y gestionar colaboradores",
    editor: "Puede modificar secciones seleccionadas",
    viewer: "Solo puede consultar secciones seleccionadas"
  },
  inviteEmail: "Dirección de correo",
  placeholder: "Introduce la dirección de correo de la persona a invitar",
  role: "Rol",
  accessToSections: "Acceso a secciones",
  resourceTypes: {
    tasks: "Tareas",
    guests: "Invitados",
    budget: "Presupuesto",
    timeline: "Cronograma"
  },
  inviteSuccess: "Invitación enviada con éxito",
  list: "Lista de colaboradores",
  empty: "Ningún colaborador por el momento",
  accessTo: "Acceso a",
  lastActive: "Última actividad",
  remove: "Eliminar colaborador",
  modifyAccess: "Modificar acceso",
  updateRoleError: "Error al actualizar el rol",
  inviteError: "Error al enviar la invitación",
  status: {
    pending: "Pendiente",
    accepted: "Aceptada",
    refused: "Rechazada",
    expired: "Expirada"
  },
  activeLinks: {
    title: "Enlaces de intercambio activos",
    description: "Administre los enlaces permanentes que permiten un acceso simplificado.",
    copy: "Copiar",
    revoke: "Revocar",
    linkCopied: "¡Enlace copiado!",
    revokeConfirm: "¿Está seguro de que desea revocar este enlace?",
    revokeSuccess: "Enlace revocado exitosamente",
    noActiveLinks: "Sin enlaces activos",
    securityInfo: "Estos enlaces permiten el acceso sin una cuenta. Compártalos con precaución."
  }
};
